import { useTranslation } from "react-i18next";
import BlurRevealText from "./BlurRevealText";

const stroke = "#003FB1";

// Order matches empower.cards in the locale files.
const cardIconTypes = [
  "brand",
  "globe",
  "rocket",
  "revenue",
  "security",
  "support",
];

function EmpowerIcon({ type }) {
  const common = {
    width: 28,
    height: 28,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
  };

  if (type === "brand") {
    return (
      <svg {...common}>
        <circle cx="16" cy="12" r="7" stroke={stroke} strokeWidth="1.75" />
        <path
          d="m11.5 17.5-2 11 6.5-3.5 6.5 3.5-2-11"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinejoin="round"
        />
        <path
          d="m16 8.5 1.4 2.9 3.1.4-2.3 2.2.6 3.1-2.8-1.5-2.8 1.5.6-3.1-2.3-2.2 3.1-.4z"
          stroke={stroke}
          strokeWidth="1.4"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === "globe") {
    return (
      <svg {...common}>
        <circle cx="16" cy="16" r="12" stroke={stroke} strokeWidth="1.75" />
        <ellipse cx="16" cy="16" rx="5" ry="12" stroke={stroke} strokeWidth="1.6" />
        <path d="M4 16h24M6 10h20M6 22h20" stroke={stroke} strokeWidth="1.6" />
      </svg>
    );
  }

  if (type === "rocket") {
    return (
      <svg {...common}>
        <path
          d="M14 20 8.5 14.5a20 20 0 0 1 2.4-4.6C14.6 4.6 20 3.5 25.5 3.5c0 5.5-1.1 10.9-6.4 14.6a20 20 0 0 1-4.6 2.4z"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinejoin="round"
        />
        <circle cx="19.5" cy="9.5" r="2.5" stroke={stroke} strokeWidth="1.6" />
        <path
          d="M8.5 22.5c-1.5 1.3-2 5.5-2 5.5s4.2-.5 5.5-2c.8-.9.8-2.3 0-3.2l-.3-.3a2.2 2.2 0 0 0-3.2 0z"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === "revenue") {
    return (
      <svg {...common}>
        <path
          d="M4 26h24"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <path
          d="M8 26v-7M14.5 26v-12M21 26v-8M27.5 26v-15"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <path
          d="m6 14 6-5 5 4 8-8"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === "security") {
    return (
      <svg {...common}>
        <path
          d="M16 3.5 27 8v8c0 7-4.5 11-11 13C9 27 4.5 23 4.5 16V8z"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinejoin="round"
        />
        <path
          d="m11.5 16 3 3 6-6"
          stroke={stroke}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  // support
  return (
    <svg {...common}>
      <path
        d="M5 16v4a2 2 0 0 0 2 2h2v-8H7a2 2 0 0 0-2 2zM27 16v4a2 2 0 0 1-2 2h-2v-8h2a2 2 0 0 1 2 2z"
        stroke={stroke}
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M8 14a8 8 0 0 1 16 0"
        stroke={stroke}
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M23 22v1a4 4 0 0 1-4 4h-3"
        stroke={stroke}
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}

function EmpowerBusinesses() {
  const { t } = useTranslation();
  const cards = t("empower.cards", { returnObjects: true });

  return (
    <section className="empower-section py-50">
      <div className="container">
        <div className="row g-4 g-xl-5 align-items-start">
          <div className="col-lg-5">
            <p className="banner-sub-heading p-2">{t("empower.overline")}</p>
            <BlurRevealText
              as="h2"
              className="empower-title"
              lines={t("empower.titleLines", { returnObjects: true })}
            />
            <p className="empower-desc">{t("empower.description")}</p>
          </div>

          <div className="col-lg-7">
            <div className="row row-cols-1 row-cols-sm-2 row-cols-xl-3 g-3 g-xl-4">
              {cards.map((card, index) => (
                <div className="col" key={card.title}>
                  <article className="empower-card h-100">
                    <span className="empower-card-icon">
                      <EmpowerIcon type={cardIconTypes[index]} />
                    </span>
                    <h3 className="empower-card-title">{card.title}</h3>
                    <p className="empower-card-text">{card.description}</p>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EmpowerBusinesses;
